import { VideoInfoRawData } from "../../../../model/video/VideoInfo.js";
import { AdCallParams, AdCOMVideoPlacement } from "../../AdCallParams.js";
import { AdUnit } from "../../AdUnit.js";
import { IMAUnmuter, isAnyUnmutable, UserGestureUnmuter } from "../../ima/UserGestureUnmuter.js";
import { VideoPolicyRules } from "../../vprules/VideoPolicyRules.js";
import { HasAdCallParamsFilter } from "../ComposableResolver.js";
import { CP_EmbedType } from "../CustomParams.js";

export class AdPlacementFilter implements HasAdCallParamsFilter {

    constructor(private policy: VideoPolicyRules, private playerType: CP_EmbedType, private unmuter?: UserGestureUnmuter, private imaUnmuter?: IMAUnmuter) {

    }

    filterAdCall(unit: AdUnit, info: VideoInfoRawData, params: AdCallParams): AdCallParams {

        const useParams: AdCallParams = params ? params : {};

        if (this.policy == VideoPolicyRules.GOOGLE_UPDATED_VIDEO_POLICY) {


            //?REQ: old logic implemented for task task #12632
            // if(this.imaUnmuter) {
            //     useParams.custom_params = useParams.custom_params?useParams.custom_params:{};
            //     useParams.custom_params.audio = this.imaUnmuter.declareMute()?"off":"on";

            // }
            //?REQ: replacement logic implemented for task #12694
            if (this.unmuter) {
                useParams.custom_params = useParams.custom_params ? useParams.custom_params : {};
                useParams.custom_params.audio = isAnyUnmutable(this.unmuter.currentUnmuteStatus()) ? "on" : "off";
            }


            if (this.playerType && (this.playerType == CP_EmbedType.VIDEO_TESTO ||
                this.playerType == CP_EmbedType.VIDEO || this.playerType == CP_EmbedType.EMBED)) {
                useParams.placement = AdCOMVideoPlacement.INSTREAM;
            } else if (this.playerType && this.playerType == CP_EmbedType.FANPLAYER) {
                useParams.placement = AdCOMVideoPlacement.ACCOMPANYING_CONTENT;
            }
            // TASK #13782
            // 
            // if (this.playerType && (this.playerType == CP_EmbedType.VIDEO_TESTO ||
            //     this.playerType == CP_EmbedType.VIDEO)) {

            //     if (this.unmuter && this.unmuter.currentUnmuteStatus().unmutedAtStart) {
            //         useParams.placement = AdCOMVideoPlacement.INSTREAM;
            //     }
            // }
            //?REQ: richiesta di fabrizio non specificare placement diversi da instream
            // else {
            //     useParams.placement = AdCOMVideoPlacement.ACCOMPANYING_CONTENT;
            // }


        }

        return useParams;
    }

}